import { z } from "zod";

import { ExclusionGroupDtoSchema } from "../../../dtos/exclusion-group";

export const GetExclusionGroupsResponseBodySchema = z.object({
  exclusionGroups: ExclusionGroupDtoSchema.array(),
});
export type GetExclusionGroupsResponseBodyType = z.infer<
  typeof GetExclusionGroupsResponseBodySchema
>;
